import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconTrendingUp = ({
  width = 16,
  height = 16,
  color = "white",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5417 7C15.5417 6.65482 15.8215 6.375 16.1667 6.375H21.1666C21.5118 6.375 21.7916 6.65482 21.7916 7L21.7917 12C21.7917 12.3452 21.5118 12.625 21.1667 12.625C20.8215 12.625 20.5417 12.3452 20.5417 12L20.5416 8.50888L13.6919 15.3586C13.5747 15.4758 13.4157 15.5417 13.25 15.5417C13.0842 15.5417 12.9252 15.4758 12.808 15.3586L9.08331 11.6339L3.27525 17.4419C3.03118 17.686 2.63545 17.686 2.39137 17.4419C2.14729 17.1979 2.14729 16.8021 2.39137 16.5581L8.64137 10.3081C8.75858 10.1908 8.91755 10.125 9.08331 10.125C9.24907 10.125 9.40804 10.1908 9.52525 10.3081L13.25 14.0328L19.6578 7.625H16.1667C15.8215 7.625 15.5417 7.34518 15.5417 7Z"
        fill={color}
      />
    </svg>
  );
};

export default IconTrendingUp;
